export default __webpack_public_path__ + "0faa6ff7308da67f44c8a507d33428dd.png";